import React from 'react';
import styled from 'styled-components';

import { ApiStatus, getNextMonthFirstDay, useApiStatus } from '../../hooks/useApiStatus';
import { CreditStatusNotice } from '../CreditStatusNotice';

const Container = styled.div`
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 1000;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

    @media (max-width: 640px) {
        right: 14px;
        bottom: 14px;
        left: 14px;
    }
`;

export const ApiStatusBadge: React.FC = () => {
    const status: ApiStatus = useApiStatus();

    const getTitle = (): string => {
        switch (status) {
            case 'ok':
                return 'Kredity dostupné';
            case 'error':
                return 'Kredity vyčerpány';
            default:
                return 'Kontroluji kredity';
        }
    };

    const getTone = () => {
        if (status === 'ok') return 'success';
        if (status === 'error') return 'danger';
        return 'neutral';
    };

    return (
        <Container>
            <CreditStatusNotice
                title={getTitle()}
                tone={getTone()}
                density="compact"
                style={{ width: 280, maxWidth: '100%' }}
            >
                {status === 'error'
                    ? `Panoramata poběží zase od ${getNextMonthFirstDay()}`
                    : status === 'ok'
                    ? 'Panoramata jsou dostupná'
                    : 'Ověřuji stav panoramat'}
            </CreditStatusNotice>
        </Container>
    );
};
